import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {LabAutomationAllSchemasQuery} from 'lab-automation/graphql/__generated/LabAutomationAllSchemasQuery';
import {LAB_AUTOMATION_ALL_SCHEMAS_QUERY} from 'lab-automation/graphql/AllSchemas';
import LookupConfigModal from 'lookup-config/LookupConfigModal';
import {RunLookupConfigModalProps} from 'lookup-config/LookupConfigUtils';
import {
  LookupSchemaSurface,
  reportLookupClosureSize,
  reportLookupConfigUnsupported,
  reportLookupSchemasReady,
  trackLookupSchemaReads,
} from 'lookup-config/lookupSchemaRum';
import {isLookupConfigValidForModal} from 'lookup-config/LookupStepInitializerUtils';
import notifications from 'notifications';
import legacyRunModal from 'ui-library/legacyRunModal';
import {withLoadingScreen} from 'util/Promises';

export default async function runLookupConfigModalForLabAutomation(
  modalProps: RunLookupConfigModalProps
): Promise<void> {
  const modalPropsWithEnvironment = {
    ...modalProps,
    allowReplicatesStep: modalProps.allowReplicatesStep ?? true,
    shouldShowIsMulti: modalProps.shouldShowIsMulti ?? true,
    shouldShowIsMultiFlatten: modalProps.shouldShowIsMultiFlatten ?? true,
    allowAlternatingGridPatterns: modalProps.allowAlternatingGridPatterns ?? true,
    shouldShowNullForEmptyContentsTooltip: true,
  };
  // Ensure all schemas are loaded
  const loadStartMs = performance.now();
  await withLoadingScreen(
    doQuerySafe<LabAutomationAllSchemasQuery>({query: LAB_AUTOMATION_ALL_SCHEMAS_QUERY})
  );
  reportLookupSchemasReady(LookupSchemaSurface.LAB_AUTOMATION_MODAL, performance.now() - loadStartMs);
  const readSet = trackLookupSchemaReads(
    () => isLookupConfigValidForModal(modalPropsWithEnvironment),
    [modalPropsWithEnvironment.baseSchema?.id]
  );
  reportLookupClosureSize(LookupSchemaSurface.LAB_AUTOMATION_MODAL, readSet);
  if (readSet.result) {
    legacyRunModal(LookupConfigModal, modalPropsWithEnvironment);
  } else {
    reportLookupConfigUnsupported(LookupSchemaSurface.LAB_AUTOMATION_MODAL);
    notifications.error('This lookup is not supported in the UI. You can still edit it in the JSON editor.');
  }
}
